"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.en = void 0;
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _en;
var en = exports.en = (_en = {
  fullname: "Name",
  gender: "Gender",
  phone: "Phone",
  dob: "Date of birth",
  find: "Find",
  createdAt: "Date created",
  action: "Action",
  detail: "Detail",
  lock: "Lock",
  unlock: "Unlock",
  customer: "Customer",
  product: "Product",
  total: "Total",
  today: "Today",
  add: "Add",
  update: "Update",
  info: "Information",
  close: "Close",
  accept: "Accept",
  customerPlaceholder: "Find customer's name",
  description: "Description",
  order: "Order",
  transport: "Transport",
  collapse: "Collapse",
  seeMore: "See more",
  originPrice: "Origin price",
  priceAfterPromotion: "Price after promotion",
  priceBeforePromotion: "Price before promotion",
  brand: "Brand",
  style: "style",
  warranty: "Warranty",
  warrantyType: "Warranty type",
  warrantyPeriod: "Warranty period",
  productPlaceholder: "Find product's name",
  orderCode: "Order Code",
  customerAddress: "Customer's address",
  cost: "Cost",
  paymentType: "Payment type",
  moneyTotal: "Provisional money",
  moneyDistance: "Transport fee",
  moneyDiscount: "Money discount",
  moneyFinal: "Final",
  CASH: "Cash",
  POINT: "Point",
  PENDING: "Pending",
  DELIVERING: "Delivering",
  COMPLETE: "Complete",
  CANCEL: "Cancel",
  galaries: "Galaries",
  remove: "Remove",
  warning: "Warning",
  status: "Status",
  FIND_DRIVER: "Find driver",
  ACCEPT_ORDER: "Accept order",
  NOT_FOUND_DRIVER: "Not found driver",
  DRIVER_CANCEL: "Driver cancel",
  CUSTOMER_CANCEL: "Customer cancel",
  SCHEDULE: "Schedule",
  startDate: "Start date",
  endDate: "End date",
  route: "Route",
  from: "From",
  to: "To",
  profit: "Profit",
  driver: "Driver",
  orderTransportPlaceholder: "Find code, name, phone",
  chooseDate: "Choose date",
  totalRevenue: "Total revenue",
  totalIncome: "Total income",
  commissionDriver: "Commission driver",
  kmNumber: "Km number",
  amountInKm: "Amount in Km",
  transportConfig: "Transport config",
  vehicleType: "Vehicle type",
  pricePerKM: "Price per KM",
  minPrice: "Min price",
  kmMinPrice: "Km min price",
  BIKE: "Bike",
  BIKE_VIP: "Bike (VIP)",
  CAR: "Car",
  vehicle: "Vehicle",
  username: "Username",
  balance: "Balance",
  vehicleName: "Vehicle name",
  licensePlate: "License plate",
  changePass: "Change password",
  FREE: "Free",
  BUSY: "Busy",
  HAVING_ORDER: "Having order",
  driverPlaceholder: "Find name, phone, license plate",
  password: "Password",
  dragImage: "Drag and drop here or",
  clickUpload: "Click to upload",
  orderHistory: "Order history",
  payHistory: "Payment history",
  transactionHistory: "Transaction history",
  change: "Change",
  balanceAfterChange: "Balance after change",
  type: "Type",
  DEPOSIT: "Deposit",
  WITHDRAW: "Withdraw",
  INCOME: "Income",
  amount: "Amount",
  DRIVER: "Deposit by digital wallet",
  STAFF: "Deposit by cash",
  form: "Form",
  depositCode: "Deposit code",
  depositNow: "Deposit now",
  withdrawCode: "Withdraw code",
  withdrawNow: "Withdraw now",
  commission: "Comission",
  note: "Note",
  distance: "Distance",
  value: "Value",
  COMMISSION_TRANSPORT: "Driver commission",
  MIN_DRIVER_BALANCE: "Balance minimum",
  DISTANCE_FIND_DRIVER: "Distance find driver",
  RATE_POINT: "Rate point",
  CASHBACK_PERCENT: "Cashback percent",
  reward: "Reward",
  notification: "Notification",
  successfully: "Successfully",
  title: "Title",
  content: "Content",
  ABOUT: "Introduce",
  FAQ: "Introduce / Introduction",
  HOW_TO_USE: "User Guide",
  SECURITY: "Private Policy",
  TERM_CONDITION: "Term of Use",
  JOIN_RULE: "RULES",
  INSURANCE_PACKAGE: "INSURANCE",
  block: "Block",
  unblock: "Unblock",
  promotion: "Promotion",
  promotionShopping: "Promotion shopping",
  promotionCallDriver: "Promotion call driver",
  time: "Time",
  conditionApply: "Condition apply",
  promotionAmount: "Promotion amount",
  totalMinimum: "Total minimum",
  kmMinimum: "KM minimum",
  promotionType: "Promotion type",
  promotionValue: "Promotion value",
  PRICE: "Amount",
  PERCENT: "Percent",
  role: "Role",
  changePassword: "Change password",
  oldPassword: "Old password",
  newPassword: "New password",
  reNewPassword: "Re-new password"
}, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_en, "config-general", "Config general"), "staff", "Staff"), "licensePlateImage", "License Plate Image"), "productList", 'Product list'), "image", 'Image'), "ratio", 'Ratio'), "search", 'Search'), "liveStreamInfo", 'Livestream info'), "watch", 'Watch'), "seller", 'Seller'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_en, "start", "Start"), "end", 'End'), "addPromotion", 'Add promotion'), "updatePromotion", 'Update promotion'), "deletePromotion", 'Delete promotion'), "startLive", 'Start livestream'), "endLive", 'Stop livestream'), "thumbnail", 'Thumbnail'), "introduce", 'Introduce'), "searchOrderCustomer", 'Search order, customer'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_en, "searchProvinceName", 'Search province name'), "province", 'Province'), "shipFee", 'Ship fee'), "save", 'Save'), "cancel", 'Cancel'), "districtList", 'District list'), "district", 'District'), "category", 'Category'), "infoBasic", 'Information basic'), "productProperty", 'Product property'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_en, "continue", 'Continue'), "goBack", 'Go back'), "productPropertyConfig", 'Property config'), "propertyName", 'Property name'), "propertyValue", 'propertyValue'), "quantity", 'Quantity'), "position", 'Position'), "backgroundColor", 'Background color'), "expire", 'Expire'), "otherInfo", 'Other information'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_en, "address", 'Address'), "shoppingOrder", 'Shopping order'), "orderPending", 'Pending'), "orderDelivering", 'Delivering'), "orderComplete", 'Completed'), "customerChart", 'Customer chart'), "orderChart", 'Order chart'), "news", 'News'), "profile", 'Profile'), "point", 'Point'), (0, _defineProperty2.default)(_en, "configPoint", 'Config point'));